import { render } from "./CarousalCompTypeTwo.vue?vue&type=template&id=e954d1a2"
import script from "./CarousalCompTypeTwo.vue?vue&type=script&lang=js"
export * from "./CarousalCompTypeTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__